import { Close } from '@zappyrent/hundop';

import {
  StyledCloseButton,
  // StyledCloseIcon,
  StyledModalHeaderWrapper,
  StyledTitle,
} from './ModalHeader.styles';

const ModalHeader = ({
  title,
  onClose,
}: {
  title: string;
  onClose: () => void;
}) => {
  return (
    <StyledModalHeaderWrapper>
      <StyledTitle>{title}</StyledTitle>
      <StyledCloseButton aria-label="close" onClick={onClose}>
        <Close />
      </StyledCloseButton>
    </StyledModalHeaderWrapper>
  );
};

export default ModalHeader;
